import axios from 'axios';
import constantes from "../constantes";
import store from "../store";

const PREFIJO="/api/VhcCtPr";

export default {
    cotizaciones() {
        const dto = {
          ndt1:store.getters.getUsuario.ndt1,
          ndt2:constantes.Constantes.enumeraciones.campana.online
        };
        return axios.post(`${PREFIJO}/VmSlVhCm`,dto);
    }
}
